// extracted by mini-css-extract-plugin
export var deleteModal = "_ei-0";